// @flow
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation ShopWithCustomerDeleteMutation(
    $input: ShopWithCustomerDeleteInput!
  ) {
    shopWithCustomerDelete(input: $input) {
      clientMutationId
      cartV2 {
        id
        totalNumberOfItems
        eventId
        eventHostFirstName
        event {
          id
          hostAccountId
          accountId
        }
      }
      viewer {
        id
        ...NavbarComponent_viewer
      }
      user {
        ...NavbarComponent_user
        id
        firstName
        lastName
        cartV2 {
          id
          totalNumberOfItems
          eventId
          eventHostFirstName
          event {
            id
            hostAccountId
            accountId
          }
        }
      }
    }
  }
`;

function commit({ environment, onCompleted, onError }) {
  return commitMutation(environment, {
    mutation,
    variables: { input: {} },
    onCompleted,
    onError,
  });
}

export default { commit };
